module.exports = "../fonts/Clear.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Clear.svg
// module id = 353
// module chunks = 0